import React from 'react'
import Modal from "@mui/material/Modal";
import closeIcon from "../../../Assets/close-icon.svg"

// Confirm gate for the live toggle's OFFLINE direction (publishing keeps its
// existing post-action modals). Same geometry as ConfirmDeleteModal; the
// caller owns the actual API call via onConfirm.
const ConfirmOfflineModal = ({ open, onCancel, onConfirm }) => {
    return (
        <Modal sx={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px" }} open={open}>
            <div className="org-modal-div merge-modal-div" >
                <div className="close-div mb-1" style={{ padding: "0px 10px 0px 0px", marginLeft: "25px" }}>
                    <img src={closeIcon} alt="close-icon" className="close-icon cursor-pointer" onClick={onCancel} />
                </div>
                <div style={{ width: "250px" }}>
                    <div className="mt-3">
                        <p className="modal-org-subtitle text-center">Are you sure you want to take this event offline?</p>
                        <p className="text-center" style={{ fontSize: "12px" }}>It will leave the public listings and stop new registrations until it is published again. Existing entries are not affected.</p>
                    </div>
                    <div className="d-flex justify-content-center gap-3 mt-2">
                        <div>
                            <button className="filled" onClick={onConfirm}>Take Offline</button>
                        </div>
                        <div>
                            <button className="filled" onClick={onCancel}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    )
}

export default ConfirmOfflineModal
